// olap-client/src/http/ChatAPI.js
import { $authHost } from './index';

// Получить список всех чатов текущего пользователя
export const GetMyChats = async () => {
  const { data } = await $authHost.get('/api/chat');
  return data;
};

// Получить детали чата
export const GetChatDetails = async (chatId) => {
  const { data } = await $authHost.get(`/api/chat/${chatId}`);
  return data;
};

// Создать новый чат
export const CreateChat = async (name, type, memberIds) => {
  const { data } = await $authHost.post('/api/chat', { name, type, memberIds });
  return data;
};

// Редактировать чат
export const UpdateChat = async (chatId, name, description) => {
  const { data } = await $authHost.put(`/api/chat/${chatId}`, { name, description });
  return data;
};

// Удалить чат
export const DeleteChat = async (chatId) => {
  const { data } = await $authHost.delete(`/api/chat/${chatId}`);
  return data;
};

// Получить историю сообщений чата
export const GetChatMessages = async (chatId, page = 1, limit = 50) => {
  const { data } = await $authHost.get(`/api/chat/${chatId}/messages?page=${page}&limit=${limit}`);
  return data;
};

// Добавить участников в чат
export const AddChatMembers = async (chatId, userIds) => {
  const { data } = await $authHost.post(`/api/chat/${chatId}/members`, { userIds });
  return data;
};

// Удалить участника из чата
export const RemoveChatMember = async (chatId, userId) => {
  const { data } = await $authHost.delete(`/api/chat/${chatId}/members/${userId}`);
  return data;
};

// Поиск пользователей для добавления в чат
export const SearchUsers = async (query) => {
  const { data } = await $authHost.get(`/api/chat/utils/search-users?q=${query}`);
  return data;
};

export const EditMessage = (messageId, text) => {
  return $authHost.put(`/api/chat/message/${messageId}`, { text });
};

export const DeleteMessage = (messageId) => {
  return $authHost.delete(`/api/chat/message/${messageId}`);
};

export const ToggleReaction = (messageId, emoji) => {
  return $authHost.post('/api/chat/message/reaction', { messageId, emoji });
};

export const ForwardMessage = (messageId, targetChatId) => {
  return $authHost.post('/api/chat/message/forward', { messageId, targetChatId });
};